import React, { createContext, useContext } from 'react';
import { WidgetModel } from '@jupyter-widgets/base';

export const WidgetModelContext = createContext<WidgetModel | undefined>(
  undefined
);

export function useWidgetModelContext() {
  const context = useContext(WidgetModelContext);
  if (context === undefined) {
    throw new Error('WidgetModelContext has to be used in proper context');
  }
  return context;
}

export interface WidgetProps {
  model: WidgetModel;
}

export const WidgetModelContextProvider = (
  Component: React.FC<WidgetProps>
): React.FC<WidgetProps> => {
  return (props: WidgetProps) => (
    <WidgetModelContext.Provider value={props.model}>
      <Component {...props} />
    </WidgetModelContext.Provider>
  );
};
